export const ContactLeftPanelItems = [
  {
    id: 1,
    name: "Dashboard",
    icon: "pi-th-large",
    key: "/dashboard",
  },
  {
    id: 2,
    name: "Plans",
    icon: "pi-book",
    key: "/plans",
  },
  {
    id: 3,
    name: "Proposals",
    icon: "pi-file",
    key: "/proposal",
  },
  {
    id: 4,
    name: "Pending",
    icon: "pi-hourglass",
    key: "/pending",
  },
  {
    id: 5,
    name: "IAPP Academy",
    icon: "pi-check-square",
    key: "/academy",
  },
];

export const ContactLeftPanelV2Items = [
  {
    id: 1,
    name: "Dashboard",
    icon: "pi-th-large",
    key: "/dashboard",
  },
  {
    id: 2,
    name: "Notifications",
    icon: "pi-bell",
    key: "/notification",
  },
  {
    id: 3,
    name: "Chat",
    icon: "pi-comments",
    key: "/chat",
  },
  {
    id: 4,
    name: "IAPP Academy",
    icon: "pi-check-square",
    key: "/academy",
  },
];
